<div *ngIf="fullDataCacheExists" class="spacer recursive-data-navigator" >
	<table *ngIf="currentStatus != 'edit-record'" id="t1" style="border-bottom-style: solid; padding:0; margin:0; border-collapse: collapse;" >
		<tr class="rdn-header-row">
			<td class="typeheader" colspan="20" style="padding-left:5px; padding-right:5px;">
				{{ currentSet.tableDisplay.label }} ({{ currentSetDataCountOfRecords > 0 ? currentSetDataCountOfRecords + ' item' + (currentSetDataCountOfRecords > 1 ? 's' : '') : '0 items' }})
				<input class="rdn-input" type='text' [ngModel]='searchText' placeholder="Enter text to search..." (ngModelChange)="searchForText($event)" style="background-color: white !important; color:black !important;" >
				<div *ngIf="allowAddRecord" class='pull-right' (click)="editRecord({type: 'add'})">
					<button class="btn btn-primary btn-round btn-icon mr-1 pull-right" title="Add a new {{currentSet.tableDisplay.entityName != null ? currentSet.tableDisplay.entityName + ' ' : ''}}record for this table." placement="left" (click)="editRecord({type: 'add'})">
						<i style="font-size: 10px" class="tim-icons white-color icon-simple-add" (click)="editRecord({type: 'add'})" > </i>
					</button>
				</div>
				<div *ngIf="allowDownloadList" class='pull-right' >
					<button [disabled]="isLoadingList" class="btn btn-success btn-round btn-icon mr-1 pull-right" title="Download the {{currentSet.tableDisplay.entityName != null ? currentSet.tableDisplay.entityName + ' ' : ''}} list into a text file." placement="left" >
						<i style="font-size: 20px" class="tim-icons white-color icon-cloud-download-93" (click)="downloadList()" > </i>
					</button>
				</div>
				<div *ngIf="allowCreateTagsForAsset" class='pull-right' >
					<button [disabled]="isLoadingList" class="btn mr-1 pull-right" (click)="updateTags()" title="Create / update tags for the current asset." placement="left" >Add/Update Tags</button>
				</div>
			</td>
		</tr>
		<thead>
			<tr style="display: table-row" class="rdn-header-row">
				<th *ngFor="let column of visibleColumns" [title]="column.title" [ngClass]="column.type" [style.width.px]="column.widthUnits == 'px' ? column.width : ''" [style.width.%]="column.widthUnits == '%' || column.widthUnits == null ? column.width : ''" >{{ column.label }}</th>
			</tr>
		</thead>
		<tbody *ngIf="isLoadingList">
			<tr style="display: table-row" ngClass="even-numbered-row-for-table">
				<td [attr.colspan]="numberOfColumns" style="padding: 5px; text-align:center">
					<div class="loading-spinner"></div>
				</td>
			</tr>
		</tbody>
		<tbody *ngIf="currentSetDataCountOfRecords == 0 && !isLoadingList">
			<tr style="display: table-row" ngClass="even-numbered-row-for-table">
				<td [attr.colspan]="numberOfColumns" style="padding: 5px; text-align:center">No records found for <strong>{{currentSet.tableDisplay.label}}</strong>.</td>
			</tr>
		</tbody>
		<tbody *ngIf="currentSetDataCountOfRecords != 0" [ngClass]="{ 'ordinal-list': allowDragAndDrop }" cdkDropList [cdkDropListDisabled]="!allowDragAndDrop" (cdkDropListDropped)="drop($event, currentSetData)">
			<tr id="{{currentSet.tableDisplay.entityName + '_' + i}}" style="display: table-row " *ngFor="let row of currentSetData ; let i = index" [ngClass]="{ 'even-numbered-row-for-table' : i % 2 == 0, 'selected-row' : currentIndex == currentSet.tableDisplay.entityName + '_' + i, 'ordinal-list-box' : allowDragAndDrop } " cdkDrag [cdkDragDisabled]="!allowDragAndDrop">
				<td [attr.colspan]="numberOfColumns">
					<table style="padding:0; margin:0; border-collapse: collapse;" >
						<!-- <tr class="clickable-row" (click)="editRecord(row, 'edit')" > -->
						<tr >
							<td class="entity" *ngFor="let column of visibleColumns" [title]="column.title" [ngClass]="column.type" [style.width.px]="column.widthUnits == 'px' ? column.width : ''" [style.width.%]="column.widthUnits == '%' || column.widthUnits == null ? column.width : ''">
								<lib-rdn-cell
									[row]="row"
									[column]="column"
									[rowIndex]="i"
									[currentSet]="currentSet"
									[isDesktopLayout]="true"
									[countOfFilesUploaded]="countOfFilesUploaded"
									(openSet)="goToSet($event.rowFieldData, $event.event)"
									(editRecord)="editRecord($event)"
									(fileUploadRecord)="openFileImageUploadWindow(currentSet.tableDisplay.entityName, (row['Name']?.value || '') + ' File Uploads', row['Id']?.value)"
									(deleteRecord)="deleteRecord($event)"
									(copyRecord)="copyRecord($event)"
									(sendToken)="sendChangePasswordToken($event.username, $event.event)"
									(resetPassword)="resetPassword($event.email, $event.username, $event.event)"
									(resetMFA)="resetMFA($event.email, $event.username, $event.event)"
									(logInAsUser)="logInAs($event.username, $event.event)"
									(viewFile)="viewFile($event)"
									(openInNewWindow)="openInNewWindow($event.url, $event.event)">
								</lib-rdn-cell>
							</td>
						</tr>
						<ng-container *ngFor="let columnName of recursiveSetColumnNamesForThisInstance">
							<tr [id]="'rdnRecursionSetContainingDiv_Id' + row[columnName].rdnRecursionSet.containingDivId"  >
								<td *ngIf="selectedRecursiveSet && selectedRecursiveSet.trElement == 'rdnRecursionSetContainingDiv_Id' + row[columnName].rdnRecursionSet.containingDivId" [attr.colspan]="numberOfColumns">
									<lib-recursive-data-navigator [options]="selectedRecursiveSet"></lib-recursive-data-navigator>
								</td>
							</tr>
						</ng-container>
					</table>
				</td>
			</tr>
		</tbody>
	</table>
</div>
<!-- Edit Form -->
<div class="spacer editing-record" *ngIf="currentStatus == 'edit-record'" >
	<div *ngIf="!loadingEditForm" class="card" >
		<div class="card-header">
			<h4 style="display: inline; vertical-align: bottom;" class="card-title">{{editFormTitle}}</h4><br />
			<h6 style="display: inline; vertical-align: bottom; font-style: italic;" class="card-title">Required fields are marked with an asterisk.</h6>
			<button class="btn btn-icon btn-simple btn-twitter pull-right" (click)="backToList()">
				<i class="tim-icons icon-minimal-left" (click)="backToList()" title="Click here to go back to the list."> </i>
			</button>
		</div>
		<div class="card-body" style="margin-top: 5px;">
			<lib-dynamic-form 
				[questions]="currentSet.editor.fields" 
				[options]="editFormOptions" 
				[entityName]="currentSet.tableDisplay.entityName" 
				[hasDynamicPropertyFields]="currentSet.editor.HasDynamicProperties" 
				(notifyParentQuestionsHaveChanged)="reloadRDNQuestions($event)" 
				(submittedValues)="submitEditForm($event)">
			</lib-dynamic-form>
		</div>
	</div>
</div>
